'use client'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils/index'

// Shared body for app/**/error.tsx and app/global-error.tsx. Takes its copy as props because
// global-error renders outside the root layout, where the next-intl provider doesn't exist.
export function RouteErrorFallback({
  title,
  description,
  retryLabel,
  onRetry,
  className,
}: {
  title: string
  description: string
  retryLabel: string
  onRetry: () => void
  className?: string
}) {
  return (
    <div
      className={cn(
        'bg-background text-foreground flex min-h-dvh w-full flex-col items-center justify-center gap-4 p-10 text-center',
        className
      )}
    >
      <h1 className="font-display text-2xl">{title}</h1>
      <p className="text-foreground/60 max-w-md text-sm">{description}</p>
      <Button onClick={onRetry}>{retryLabel}</Button>
    </div>
  )
}
